export { FooterTemplate } from './footer'
